import MarkUnreadChatAltOutlined from "@mui/icons-material/MarkUnreadChatAltOutlined";
import { usePermissions } from "../../../server/auth/use-permissions";
import { useAccountLimitsContext } from "../../context/account-limit-context";
import { useInboxCount } from "../../layout/components/sidebar/hooks/use-inbox-count";
import { HeaderCount } from "./header-count";

import type { FC } from "react";

/**
 * People with unread SMS replies, as the sidebar's Inbox badge shows. Only super admins can read
 * the count (and see the Inbox), and only accounts with two-way SMS get replies, so it is hidden for
 * everyone else, and if the count fails.
 */
export const UnreadInboxCount: FC = () => {
  const { super_admin } = usePermissions();
  const { enable_sms_two_way } = useAccountLimitsContext();
  const enabled = super_admin && enable_sms_two_way;
  const { count, error } = useInboxCount(enabled);

  if (!enabled || error) return null;

  return (
    <HeaderCount
      icon={<MarkUnreadChatAltOutlined fontSize="small" />}
      to="/inbox"
      count={count}
      noneTooltip="No new replies"
      someTooltip="You have new unread replies"
    />
  );
};
